<template lang="">
  <div class="mains">
    <div class="container">
      <div class="header_title">产品管理</div>
      <div class="top">
        <Button class="newBotton" @click="inAddVal()">
          <span class="newBottonText">新增</span>
        </Button>
        <div class="select">
          <Input
            v-model="selectVal"
            @on-search="selectbtn()"
            search
            placeholder="输入标题"
          />
        </div>
        <div class="select" style="line-height: 35px">
          共 {{ allPage }} 条记录
        </div>
      </div>
      <div class="main mains">
        <el-empty description="没有数据哦！" v-if="pageData.length == 0" />
        <Table
          border
          :columns="columns"
          :data="pageData"
          style="width: 100%"
          v-if="pageData.length !== 0"
        >
          <!-- <Table border :columns="columns" :data="datas" style="width:100%;"> -->
          <template #name="{ row }">
            <strong>{{ row.name }}</strong>
          </template>
          <template #action="{ row, index }">
            <Button style="margin-right: 5px" @click="show(index)">修改</Button>
            <Button type="error" @click="remove(index)">删除</Button>
          </template>
        </Table>
        <!-- 分页 -->
        <Page
          class="page"
          :modelValue="pages"
          :total="allPage"
          simple
          @on-change="page"
        />
      </div>

      <Drawer
        title="修改产品信息"
        :closable="false"
        v-model="value"
        width="600"
      >
        <updataFiled
          :datas="pageData[index]"
          @results="updataFileds"
        ></updataFiled>
      </Drawer>
      <Drawer title="添加产品" :closable="false" v-model="addVal" width="600">
        <NewFiled @change="addClientList" @close="NewFiledClose"></NewFiled>
      </Drawer>
    </div>
  </div>
</template>
<script>
import NewFiled from "@/views/product/newFiled";
import updataFiled from "@/views/product/updataFiled";
import { GetProductList, DelProductList } from "@/api/index";
export default {
  data() {
    return {
      selectVal: "",
      value: false,
      addVal: false,
      columns: [
        {
          title: "ID",
          key: "id",
          width: 100,
        },
        {
          title: "企业代码",
          key: "clientCode",
          width: 120,
        },
        {
          title: "产品编号",
          key: "title",
          width: 200,
        },
        {
          title: "产品名称",
          key: "ProductName",
          width: 200,
        },
        {
          title: "添加时间",
          key: "time",
          width: 200,
        },
        {
          title: "备注",
          key: "remark",
          minWidth: 200,
        },
        {
          title: " ",
          slot: "action",
          width: 170,
          align: "center",
          fixed: "right",
        },
      ],
      // 分页后的数据
      pageData: [],
      inDatas: {
        inCode: "",
        inName: "",
        inWrite: "",
        inDate: "",
      },
      pages: 1,
      allPage: 1,
      index: "",
    };
  },
  components: {
    NewFiled,
    updataFiled,
  },
  beforeCreate() {},
  mounted() {},
  watch: {},
  created() {
    let control = this.$store.state.control;
    if (control !== "1") {
      this.columns = this.columns.filter((p, key) => {
        if (p.title !== "企业代码") {
          return p;
        }
      });
    }
    this.getProducts();
  },
  methods: {
    selectbtn() {
      this.getProducts();
    },
    // 获取产品信息
    getProducts() {
      GetProductList({
        code: 1,
        page: this.pages,
        pagesize: 10,
        name: this.selectVal,
      }).then((res) => {
        this.pageData = res.list;
        this.allPage = res.size;
      });
    },
    NewFiledClose() {
      this.addVal = false;
      this.$message({
        type: "success",
        message: "添加成功!",
      });
      this.getProducts();
    },
    updataFileds(value) {
      // console.log(value);
      this.pageData[this.index].title = value.title;
      this.pageData[this.index].datas = value.arr;
      this.value = false;
    },
    inAddVal(index) {
      this.addVal = true;
    },
    show(index) {
      this.index = index;
      this.value = true;
    },
    // 分页过滤
    page(i) {
      this.pages = i;
      this.getProducts();
      // var data = this.datas.filter((p) => {
      //   return p.name.indexOf(this.selectVal) !== -1;
      // });
      // // this.pages = 1
      // let arr = data.filter((p, key) => {
      //   if (key < this.pages * 10 && key >= this.pages * 10 - 10) {
      //     return p;
      //   }
      // });
      // this.pageData = arr;
    },
    // 接收来自子组件的回值---添加信息
    async addClientList(value) {
      this.datas.push(value);
    },
    // 删除按钮
    remove(index) {
      const title = this.pageData[index].title;
      const code = this.pageData[index].clientCode;
      const id = this.pageData[index].id;
      this.$confirm("此操作将永久删除该" + title + "字段, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 提交删除请求
          DelProductList({
            id,
          }).then((res) => {
            if (res.code == 402) {
              this.$Notice.error({ title: "没有权限！" });
            }
            if (res == 1) {
              this.pageData.splice(index, 1);
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败！",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style scoped>
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
